module.exports = __webpack_public_path__ + "img/reed-plaza-474x316.8ceca340.jpg";